<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="white-card">
        <div class="header-title-row" style="padding-bottom: 16px">
          <div class="header-left">
            <img
              src="assets/svg/goals-icon.svg"
              alt="oportunidades"
              class="center-svg"
            />
            <h1 class="text-semibold color-org t-24">Metas</h1>
          </div>

          <div class="header-actions">
            <div class="text-center event-item">
              <button class="btn btn-round-outline" (click)="updateChart()">
                <img class="center-svg" src="assets/svg/reload-icon-org.svg" />
              </button>
            </div>

            <button class="action-btn primary" (click)="goToGoals()">
              <img
                src="assets/svg/list-menu.svg"
                alt="Añadir nuevo"
                width="16"
                height="16"
                
              />
              Ver lista metas
            </button>
          </div>

          <div class="open-tab-title" style="padding-top: 3px">
            <div style="padding-top: 3px">
              <div class="d-grid general-title">
                <div><h2 class="text-semibold">Vista Resumen</h2></div>
                <div class="d-grid filter-opportunities">
                  <div class="d-grid filter-opp">
                    <div>Fecha</div>
                    <select name="" id="">
                      <option value="">Todos los meses</option>
                    </select>
                  </div>

                  <div class="text-center event-item">
                    <button class="btn btn-round-outline btn-mark">
                      <img
                        class="center-svg"
                        src="assets/svg/bookmark-icon.svg"
                      />
                    </button>
                  </div>
                  <div class="text-center event-item">
                    <button class="btn btn-round-outline">
                      <img
                        class="center-svg"
                        src="assets/svg/filterpng-icon.svg"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <div class="d-grid progress-status-row mt-3">
                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-1.svg"
                        alt="icono ingresadas"
                        class="card-icon"
                      />
                      <span class="card-title">Metas en curso</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">{{ metasEnCursoFormatted }}</b>
                    </div>
                  </div>
                </div>
                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-2.svg"
                        alt="icono ingresadas"
                        class="card-icon"
                      />
                      <span class="card-title">%cumplimiento</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">{{ porcentajeCumplimiento }}</b>
                      %
                    </div>
                  </div>
                </div>
                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-4.svg"
                        alt="icono ingresadas"
                        class="card-icon"
                      />
                      <span class="card-title">Total alcanzado</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">{{ totalAlcanzadoFormatted }}</b>
                    </div>
                  </div>
                </div>
                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-3.svg"
                        alt="icono ingresadas"
                        class="card-icon"
                      />
                      <span class="card-title">Total oportunidades ganadas</span>
                    </div>
                    <div class="card-body" style="text-align: center">
                      <b class="card-amount-bold">{{ oportunidadesGanadas }}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--vista de las tendencias-->
          <div class="open-tab-title" style="padding-top: 3px">
            <div style="padding-top: 3px">
              <div class="gg-d-grid gg-mdl-header">
                <div class="gg-center-svg">
                  <img
                    src="assets/svg/charts-icon.svg"
                    alt=""
                    style="width: 46px; height: 46px"
                  />
                </div>
                <div>
                  <h4 class="gg-text-semibold" style="font-size: 20px">
                    Tendencia Anual de Cumplimiento de Metas de todo los
                    ejecutivos
                  </h4>
                </div>
              </div>

              <!-- Gráfico de líneas -->
              <div class="gg-chart-container">
                <canvas
                  *ngIf="isBrowser"
                  baseChart
                  [data]="{ labels: lineChartLabels, datasets: lineChartDatasets }"
                  [options]="lineChartOptions"
                  [type]="'line'"
                >
                </canvas>
              </div>

              <div class="d-grid progress-status-row mt-3"></div>
            </div>
          </div>

          <div class="gg-graficos-grid-container">
            <!-- Gráfico 1: Ejecutivo vs. Meta Mensual -->
            <div class="gg-figma-container">
              <div class="gg-d-grid gg-mdl-header gg-custom-header-line">
                <div class="gg-center-svg">
                  <img
                    src="assets/svg/charts-icon.svg"
                    alt=""
                    style="width: 46px; height: 46px"
                  />
                </div>
                <div>
                  <h4 class="gg-text-semibold" style="font-size: 20px">
                    Ejecutivo vs. Meta Mensual
                  </h4>
                </div>
              </div>

              <!-- Gráfico de barras apiladas -->
              <div class="gg-chart-container">
                <canvas
                  *ngIf="isBrowser"
                  baseChart
                  [data]="{ labels: barChartExecutivesLabels, datasets: barChartExecutivesDatasets }"
                  [options]="barChartExecutivesOptions"
                  [legend]="true"
                  [type]="'bar'"
                >
                </canvas>
              </div>

              <!-- Lista de ejecutivos en dos columnas -->
              <div
                class="gg-executives-list-container"
                *ngIf="executivesListData.length > 0"
              >
                <div class="gg-executives-grid">
                  <div class="gg-executives-column">
                    <div
                      *ngFor="let ejecutivo of executivesListData.slice(0, 5); let i = index"
                      class="gg-executive-item"
                    >
                      <div
                        class="gg-executive-color"
                        [style.background-color]="ejecutivo.color"
                      ></div>
                      <div class="gg-executive-info">
                        <div class="gg-executive-name">{{ ejecutivo.nombre }}</div>
                        <div class="gg-executive-amount">
                          {{ ejecutivo.formattedAvance }}
                        </div>
                        <div class="gg-executive-meta">
                          Meta: {{ formatCurrencyPublic(ejecutivo.meta_proyectada) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="gg-executives-column">
                    <div
                      *ngFor="let ejecutivo of executivesListData.slice(5, 10); let i = index"
                      class="gg-executive-item"
                    >
                      <div
                        class="gg-executive-color"
                        [style.background-color]="ejecutivo.color"
                      ></div>
                      <div class="gg-executive-info">
                        <div class="gg-executive-name">{{ ejecutivo.nombre }}</div>
                        <div class="gg-executive-amount">
                          {{ ejecutivo.formattedAvance }}
                        </div>
                        <div class="gg-executive-meta">
                          Meta: {{ formatCurrencyPublic(ejecutivo.meta_proyectada) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="executivesListData.length > 10"
                  class="gg-remaining-executives"
                >
                  <div class="gg-remaining-title">
                    Otros Ejecutivos ({{ executivesListData.length - 10 }})
                  </div>
                  <div class="gg-remaining-grid">
                    <div
                      *ngFor="let ejecutivo of executivesListData.slice(10)"
                      class="gg-executive-item gg-small"
                    >
                      <div
                        class="gg-executive-color"
                        [style.background-color]="ejecutivo.color"
                      ></div>
                      <div class="gg-executive-info">
                        <div class="gg-executive-name">{{ ejecutivo.nombre }}</div>
                        <div class="gg-executive-amount">
                          {{ ejecutivo.formattedAvance }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Gráfico 2: Porcentaje de cumplimiento total mes -->
            <div class="gg-figma-container-torta">
              <div class="gg-d-grid gg-mdl-header gg-custom-header-line">
                <div class="gg-center-svg">
                  <img
                    src="assets/svg/charts-icon.svg"
                    alt=""
                    style="width: 46px; height: 46px"
                  />
                </div>
                <div>
                  <h4 class="gg-text-semibold" style="font-size: 20px">
                    Porcentaje de cumplimiento total mes
                  </h4>
                </div>
              </div>

              <!-- Gráfico de torta -->
              <div class="gg-chart-container-torta">
                <canvas
                  *ngIf="isBrowser"
                  baseChart
                  [labels]="doughnutChartLabels"
                  [datasets]="doughnutChartDatasets"
                  [options]="doughnutChartOptions"
                  [legend]="false"
                  [type]="'doughnut'"
                >
                </canvas>
              </div>

              <!-- Leyenda del gráfico -->
              <div
                class="gg-executives-list-container"
                *ngIf="doughnutChartDatasets && doughnutChartDatasets.length > 0"
              >
                <div class="gg-executives-grid">
                  <!-- Columna izquierda -->
                  <div class="gg-executives-column">
                    <div
                      *ngFor="let label of doughnutChartLabels.slice(0, 1); let i = index"
                      class="gg-executive-item"
                    >
                      <div
                        class="gg-executive-color"
                        [style.background-color]="getBackgroundColor(i)"
                      ></div>
                      <div class="gg-executive-info">
                        <div class="gg-executive-name">{{ label }}</div>
                        <div class="gg-executive-amount">
                          {{ getFormattedData(i) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Columna derecha -->
                  <div class="gg-executives-column">
                    <div
                      *ngFor="let label of doughnutChartLabels.slice(1, 2); let i = index"
                      class="gg-executive-item"
                    >
                      <div
                        class="gg-executive-color"
                        [style.background-color]="getBackgroundColor(i + 1)"
                      ></div>
                      <div class="gg-executive-info">
                        <div class="gg-executive-name">{{ label }}</div>
                        <div class="gg-executive-amount">
                          {{ getFormattedData(i + 1) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Gráfico 3: Avance mensual de los ejecutivos -->
            <div class="gg-figma-container-semanal">
              <div class="gg-d-grid gg-mdl-header gg-custom-header-line">
                <div class="gg-center-svg">
                  <img
                    src="assets/svg/charts-icon.svg"
                    alt=""
                    style="width: 46px; height: 46px"
                  />
                </div>
                <div>
                  <h4 class="gg-text-semibold" style="font-size: 20px">
                    Avance mensual de los ejecutivos
                  </h4>
                </div>
              </div>

              <!-- Gráfico de líneas para avance semanal -->
              <div class="gg-chart-container-semanal">
                <canvas
                  *ngIf="isBrowser"
                  baseChart
                  [data]="lineChartWeeklyData"
                  [options]="lineChartWeeklyOptions"
                  [type]="'line'"
                >
                </canvas>
              </div>

              <!-- Leyenda simple -->
              <div class="gg-semanal-legend">
                <div class="gg-legend-row">
                  <div class="gg-legend-item-simple">
                    <div
                      class="gg-legend-dot"
                      style="background-color: #ea5a10"
                    ></div>
                    <span class="gg-legend-text-simple">Avance real</span>
                  </div>
                  <div class="gg-legend-item-simple">
                    <div
                      class="gg-legend-dot"
                      style="background-color: #8d8d8d"
                    ></div>
                    <span class="gg-legend-text-simple">Meta proyectada</span>
                  </div>
                </div>
                <div class="gg-mes-info">Mes: {{ getMesActual() }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>